export default __webpack_public_path__ + "static/media/red_bg.f0a34768.svg";